import { Input, Directive } from '@angular/core';
import { IpScope } from 'DiscoveryEngine.TS/Core';
import { ComponentBase, Changeable } from "common";
import { ScheduledDiscovery, DiscoverySettings } from 'DiscoveryEngine.TS/Discovery';
import { FormBuilder, UntypedFormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { NetFacadeService } from 'netview';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';


@Directive()
export abstract class SchedDiscConfigComponentBase extends ComponentBase implements Changeable  {

	@Input() Discovery: ScheduledDiscovery;

	public Settings: DiscoverySettings;
	public Agent: AgentDto;
	public Network: NetViewDto;

	public SettingsForm: UntypedFormGroup;

	constructor(private netFacadeService: NetFacadeService) {
		super();

		this.Discovery = null;
		this.Settings = null;
		this.Agent = null;
		this.Network = null;
	}

	protected abstract BuildForm(): void;

	public get tempChanges(): boolean {
		return this.SettingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.SettingsForm.valid;
	}

	public abstract get invalidTempChanges(): string[];

	public abstract applyTempChanges(): void;

	public discardTempChanges(): void {
		this.BuildForm();
	}

	protected SaveScope(scope: IpScope, str: string): void {
		scope.FromString(str);
	}

	protected onChanges(): void {
		this.Settings = null;
		this.Agent = null;
		this.Network = null;

		if (this.Discovery) {
			if (this.Discovery.HasDiscSettingsId) {
				this.Settings = this.netFacadeService.findSchedDiscSettings(
					this.Discovery.GUID, this.Discovery.DiscSettingsId.ToString());
			}
			else {
				console.error("Missing discovery settings");
			}

			this.Agent = this.netFacadeService.findSchedDiscParent(this.Discovery.GUID);
			if (this.Agent) {
				this.Network = this.netFacadeService.findAgentParent(this.Agent.Guid);
				if (!this.Network) {
					console.error("Missing discovery network");
				}
			}
			else {
				console.error("Missing discovery agent");
			}
		}
	}

	protected onApplyTempChanges(): void {
		if (this.Agent) {
			this.Agent.HasChanges = true;
		}
	}

}